<script>
/* eslint-disable no-unused-vars */
import { MeanChart } from "@/redem/datafiles/result-charts.js";
import DatafileReportService from "@/api/services/datafileReport.service.js";
import { GLOBALS } from "@/shared/util/globals.js";

export default {
  props: {
    datafileId: String
  },
  data() {
    return {
      meanChartOptions: null,
      chartDataForCleanedTimeScoreChart: 85,
      chartDataForRawTimeScoreChart: 78
    };
  },
  async created() {
    await this.fetchChartData();
    this.meanChartOptions = new MeanChart();
  },
  methods: {
    async fetchChartData() {
      const tScores = await DatafileReportService.getReportAverageTimeScore(
        this.datafileId,
        GLOBALS.reportPassword
      );
      this.$emit("finishLoading");
      this.chartDataForRawTimeScoreChart = tScores[0];
      this.chartDataForCleanedTimeScoreChart = tScores[1];
    }
  }
};
</script>

<template>
  <div class="card" style="border: 1px solid #f5f5f5">
    <div class="card-body">
      <div class="card-title">
        {{ $t("datafileReport.qualityScoresModal.ts.title") }}
      </div>
      <div class="card-text" style="height: 120px;">
        {{ $t("datafileReport.qualityScoresModal.ts.description") }}
      </div>
      <div class="card-text">
        <div class="row mt-4">
          <div class="col-md-12 text-center">
            <b-tabs>
              <!-- Clean Tab -->
              <b-tab active lazy>
                <template v-slot:title>
                  {{ $t("datafileReport.cleaned") }}
                </template>
                <div>
                  <apexchart
                    ref="PSMeanChart"
                    class="apex-charts apexChartData"
                    type="radialBar"
                    height="250"
                    dir="ltr"
                    :series="[chartDataForCleanedTimeScoreChart]"
                    :options="meanChartOptions.chartOptions"
                  ></apexchart>
                </div>
              </b-tab>
              <!-- Raw Tab -->
              <b-tab lazy>
                <template v-slot:title>
                  {{ $t("datafileReport.raw") }}
                </template>
                <div>
                  <apexchart
                    ref="PSMeanChart"
                    class="apex-charts apexChartData"
                    type="radialBar"
                    height="250"
                    dir="ltr"
                    :series="[chartDataForRawTimeScoreChart]"
                    :options="meanChartOptions.chartOptions"
                  ></apexchart>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
